// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605141607/js/" + chunkId + "." + {"44":"7796f69f","225":"7595326a","481":"13c91709","486":"3b73badf","770":"8c96716e"}[chunkId] + ".0.114877818179844.chunk.js";
};